import type { Namespace } from './types';
export const zh: Namespace = {
  cdkeys: {
    title: 'CDKey',
    empty: '没有符合条件的 CDKey',
    states: {
      10: '可用',
      40: '已核销',
      unknown: '未知状态',
    },
    fields: {
      code: 'CDKey',
      state: '状态',
      expected: '面额',
      effectDay: '有效天数',
      username: '关联账号',
      orderNo: '关联订单',
      remark: '备注',
    },
    kpi: {
      states: '状态',
      amountTotal: '面额合计',
      amountUnused: '未核销面额',
    },
    actions: {
      mint: '新增CDKey',
      minted: '已新增 {{count}} 个 CDKey',
      edit: '编辑',
      delete: '删除',
      deleteConfirm: '删除 {{count}} 个 CDKey？',
      batchDelete: '批量删除',
      done: '操作已提交',
    },
    hints: {
      undeletableSelected: '所选中有 {{count}} 个不可删除的 CDKey，它们不会被删除。',
    },
    modal: {
      mintTitle: '新增CDKey',
      editTitle: '编辑 CDKey',
      count: '数量',
      countRange: '数量需在 1 到 500 之间',
      effectDay: '有效天数',
      amount: '面额',
      amountKeep: '不改额度',
      unit: '币种',
      remark: '备注',
      remarkPlaceholder: '例：9 月活动批次 / 客户 A 专供',
    },
    result: {
      copyAll: '复制全部（{{count}} 个）',
      empty: '本次没有回显卡号',
    },
    search: {
      code: 'CDKey',
    },
  },
};

export const en: Namespace = {
  cdkeys: {
    title: 'CDKeys',
    empty: 'No CDKeys match the filters',
    states: {
      10: 'Available',
      40: 'Redeemed',
      unknown: 'Unknown state',
    },
    fields: {
      code: 'CDKey',
      state: 'State',
      expected: 'Card value',
      effectDay: 'Validity (days)',
      username: 'Linked account',
      orderNo: 'Linked order',
      remark: 'Note',
    },
    kpi: {
      states: 'State',
      amountTotal: 'Total card value',
      amountUnused: 'Unused card value',
    },
    actions: {
      mint: 'Add CDKeys',
      minted: 'Added {{count}} CDKey(s)',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Delete {{count}} CDKey(s)?',
      batchDelete: 'Delete selected',
      done: 'Submitted',
    },
    hints: {
      undeletableSelected: '{{count}} selected CDKey(s) cannot be deleted and will be skipped.',
    },
    modal: {
      mintTitle: 'Add CDKey',
      editTitle: 'Edit CDKey',
      count: 'Count',
      countRange: 'Count must be between 1 and 500',
      effectDay: 'Validity (days)',
      amount: 'Card value',
      amountKeep: 'Leave unchanged',
      unit: 'Currency',
      remark: 'Note',
      remarkPlaceholder: 'e.g. September batch / reserved for client A',
    },
    result: {
      copyAll: 'Copy all ({{count}})',
      empty: 'No codes were returned',
    },
    search: {
      code: 'CDKey',
    },
  },
};
